import EstructureLogin from "../../component/EstructureLogin.js"
import LoginForm from "./LoginForm.js"
import "./../../assets/css/style.css";  

export default function Login() {   
 return(
   <EstructureLogin componente={<LoginForm/>}/>
 )
}